import React from 'react';
import classNames from 'classnames';

import { ButtonProps } from './Button.types';
import styles from './Button.module.scss';

export function Button({ variant = 'default', children, onClick, isActive = false, className, ...rest }: ButtonProps) {
  const buttonClass = classNames(styles.button, styles[`button-${variant}`], { [styles.active]: isActive }, className);

  return (
    <button className={buttonClass} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
